import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function LoginForm() {
    const [loginIdentifier, setLoginIdentifier] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    
    const navigate = useNavigate();
    const { login } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setMessage('');

        try {
            const loggedInUser = await login(loginIdentifier, password);
            
            // --- THIS IS THE CORRECTED PART ---
            // The URL was incorrect and has been fixed.
            if (loggedInUser.role === 'admin' || loggedInUser.role === 'superadmin') {
                navigate('/portal-management-7a8b9c');
            } else {
                navigate('/my-dashboard');
            }
        } catch (error) {
            setMessage(error.message || 'Login failed.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md border-t-4 border-brand-primary">
            <h2 className="text-3xl font-bold text-brand-primary text-center mb-6">Member Login</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
                <input 
                    type="text" 
                    value={loginIdentifier} 
                    onChange={(e) => setLoginIdentifier(e.target.value)} 
                    placeholder="Email or Phone Number" 
                    required 
                    className="w-full p-3 bg-gray-50 text-gray-800 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-brand-primary" 
                />
                <input 
                    type="password" 
                    value={password} 
                    onChange={(e) => setPassword(e.target.value)} 
                    placeholder="Password" 
                    required 
                    className="w-full p-3 bg-gray-50 text-gray-800 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-brand-primary" 
                />
                <button type="submit" disabled={isLoading} className="w-full p-3 bg-brand-primary hover:bg-red-900 rounded-md font-bold text-white transition-colors disabled:bg-gray-400">
                    {isLoading ? 'Logging In...' : 'Login'}
                </button>
                {message && <p className="text-red-500 text-center mt-4">{message}</p>}
            </form>
        </div>
    );
}

export default LoginForm;

